import * as crypto from 'crypto';
export class DiscourseValidationService {
    static $inject = ['AccountService2', 'DISCOURSE_SSO_SECRET', 'FORUM_URI'];
    constructor(AccountService2, DISCOURSE_SSO_SECRET, FORUM_URI) {
        'ngInject';
        this.AccountService2 = AccountService2;
        this.DISCOURSE_SSO_SECRET = DISCOURSE_SSO_SECRET;
        this.FORUM_URI = FORUM_URI;
    }
    validate(payload, sig) {
        const hmac = crypto.createHmac('sha256', this.DISCOURSE_SSO_SECRET);
        hmac.update(decodeURIComponent(payload));
        if (hmac.digest('hex') === sig) {
            return true;
        }
        else {
            return false;
        }
    }
    getQueryString(payload) {
        return ('?' +
            decodeURIComponent(new Buffer(decodeURIComponent(payload), 'base64').toString()));
    }
    getNonce(payload) {
        return this.getParameterByName('nonce', this.getQueryString(payload));
    }
    getReturnUrl(payload) {
        return this.getParameterByName('return_sso_url', this.getQueryString(payload));
    }
    buildLoginString(params) {
        const payload = new Buffer(params, 'utf8').toString('base64');
        const hmac = crypto.createHmac('sha256', this.DISCOURSE_SSO_SECRET);
        hmac.update(payload);
        return `?sso=${payload}&sig=${hmac.digest('hex')}`;
    }
    //Most voted answer at https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
    getParameterByName(name, url) {
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
        if (!results) {
            return undefined;
        }
        if (!results[2]) {
            return '';
        }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
    getRedirectUrl(payload, sig, account) {
        let finalRedirectUrlQueryString = '';
        let returnUrl = '';
        if (payload && sig) {
            // Is this a valid login aattempt?
            if (this.validate(payload, sig)) {
                const nonce = this.getNonce(payload); // this is my key so that discourse knows this is a valid request
                returnUrl = this.getReturnUrl(payload); // the url I'm going to redirect the user after portal validation was successful (if the login was successful)
                const externalId = account.id; // The user's database id
                const name = account.fullName; // this can override discourse's full name value if discourse is configured to let it happen
                const email = account.email; // the usual credentials; in this case, just the email
                const username = account.fullName; // this can override discourse's username value if discourse is configured to let it happen
                //creating the query for the rdirect url
                const redirectUrlQueryString = `nonce=${nonce}&name=${name}&username=${username}&email=${encodeURIComponent(email)}&external_id=${externalId}`;
                // the final query string to append to the redirect url
                finalRedirectUrlQueryString = this.buildLoginString(redirectUrlQueryString);
            }
        }
        //return returnUrl + finalRedirectUrlQueryString;
        return this.FORUM_URI + finalRedirectUrlQueryString;
    }
    async redirectToDiscourse(payload, sig) {
        if (payload && sig) {
            const me = await this.AccountService2.me();
            const discourseRedirectUrl = this.getRedirectUrl(payload, sig, me);
            if (discourseRedirectUrl) {
                window.open(discourseRedirectUrl, '_self');
            }
        }
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
DiscourseValidationService.$inject = ['AccountService2', 'DISCOURSE_SSO_SECRET', 'FORUM_URI'];
